import { colors } from '@bonitour/components'

export const affiliateStatusMap = {
  active: ['Ativo', colors.green3],
  pending: ['Pendente', colors.orange3],
  inactive: ['Inativo', colors.red2]
}
